import Countries from './Countries.json';
import countryCodes from './countryCodes.json';
import Constants from './Constants';

/** ISO 3166-1 alpha-3 code with its display name (Country of Recording). */
export interface CountryCode {
  code: string;
  name: string;
}

export { Constants, countryCodes };
export default Countries;
